import { render, staticRenderFns } from "./orderCreate.vue?vue&type=template&id=c409c5a4&scoped=true"
import script from "./orderCreate.vue?vue&type=script&lang=js"
export * from "./orderCreate.vue?vue&type=script&lang=js"
import style0 from "./orderCreate.vue?vue&type=style&index=0&id=c409c5a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c409c5a4",
  null
  
)

export default component.exports